import React from 'react';
import { Document, Image, Page, StyleSheet } from '@react-pdf/renderer';
import { useStore } from 'store';
import { numberWithCommas } from 'utils';
import QuoteItemsTable from './QuoteItemsTable';
import QuoteMgs from './QuoteMsg';
import QuoteTitle from './QuoteTitle';
import headerImage from "./tmtheader.png"

// Create styles
const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 11,
    paddingTop: 30,
    paddingLeft:60,
    paddingRight:60,
    lineHeight: 1.5,
    flexDirection: 'column',
  }, 
  logo: {
      width: '450px',
      marginLeft: 'auto',
      marginRight: 'auto'
  },
  themeImage: {
    position: "absolute",
    width: '500px',
    top: '50px',
    left: '50%',
    marginLeft: '-250px',
    zIndex: 1
  },
  tableImage: {
    position: "absolute",
    width: '500px',
    top: '50px',
    left: '50%',
    marginLeft: '-250px',
	  zIndex: 2
  },
  ringImage: {
    position: "absolute",
    width: '500px',
    top: '50px',
    left: '50%',
    marginLeft: '-250px',
    zIndex: 3
  }
});

// Create Document Component
function PdfDocument ({ data }) {
    const { rotation, size, theme, table, ring, control, powerSupply } = useStore.getState()

    const options = {
        rotation: rotation && data.rotations[rotation],
        size: size && data.sizes[size],
        theme: theme && data.themes[theme],
        table: table && data.tables[table],
        ring: (rotation === "pole") ? false : (ring && data.rings[ring]),
        control: control && data.addons.control[control],
        power: powerSupply ? data.addons.powerSupply : false
    }

    // let themeImage = options.theme && options.theme.imageFront.url
	  // let tableImage = options.table && options.table.imageFront.url
	  // let ringImage = options.ring && options.ring.imageFront.url

    const basePrice = data.basePrice || 0

    // Final price, adding everything together
    const price = basePrice
      + (options.rotation ? options.rotation.price : 0)
      + (options.size ? options.size.price : 0)
      + (options.theme ? options.theme.price : 0)
      + (options.table ? options.table.price : 0)
      + (options.ring ? options.ring.price : 0)
      + (options.control ? options.control.price : 0)
      + (options.power ? options.power.price : 0)

    const preparedData = {
      items: [
        {
          type: "Rotation",
          label: options.rotation.label, // User have to pick rotation
          price: numberWithCommas(Number(options.rotation.price).toFixed(2)) + ' €'
        },
        {
          type: "Size",
          label: options.size.label, // User have to pick size
          price: numberWithCommas(Number(options.size.price).toFixed(2)) + ' €'
        },
        {
          type: "Theme",
          label: options.theme ? options.theme.label : "-",
          price: options.theme ? numberWithCommas(Number(options.theme.price).toFixed(2)) + ' €' : '0 €'
        },
        {
          type: "Table",
          label: options.table ? options.table.label : "-",
          price: options.table ? numberWithCommas(Number(options.table.price).toFixed(2)) + ' €' : '0 €'
        },
        {
          type: "Control",
          label: options.control ? options.control.label : "-",
          price: options.control ? numberWithCommas(Number(options.control.price).toFixed(2)) + ' €' : '0 €'
        },
        {
          type: "230V Power supply",
          label: options.power ? "Yes" : "No",
          price: options.power ? numberWithCommas(Number(options.power.price).toFixed(2)) + ' €' : '0 €'
        }
      ],
      totalPrice: price
    }

    if (options.ring) {
      preparedData.items.push({
        type: "Ring",
        label: options.ring ? options.ring.label : "-",
        price: options.ring ? numberWithCommas(Number(options.ring.price).toFixed(2)) + ' €' : '0 €'
      })
    }

    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <Image style={styles.logo} src={headerImage} />
          {/* <Image style={styles.themeImage} src={themeImage} />
          <Image style={styles.tableImage} src={tableImage} />
          <Image style={styles.ringImage} src={ringImage} /> */}
          <QuoteTitle title='Quote'/>
          <QuoteItemsTable data={preparedData} />
          <QuoteMgs />
        </Page>
      </Document>
    )
}

export default PdfDocument